'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
	(function (ProductSubscription, $) {
		var $dom = {};

		var cacheDom = function cacheDom() {
			$dom.ProductDropdown = $('[data-product-dropdown]');
			$dom.ProductSelect = $('[data-subscription-select]');
			$dom.frequencySelect = $('[data-frequency-selecter]');
		};

		var bindUIActions = function bindUIActions() {
			$('body').on('click', '[data-product-dropdown] li', function () {
				var selectedValue = $(this).parents('.dropdown').find('span').attr('data-handle');
				$('[data-subscription-select]').val(selectedValue);
			});
		};

		var bindUIActionsNew = function bindUIActionsNew() {
			$('body').on('click', '[data-frequency-selecter] .rc_frequencySelecter__item', function () {
				$(this).parents('.rc_frequencySelecter').find('.rc_frequencySelecter__item').removeClass('is-active');
				$(this).addClass('is-active');
				var selectedValueNew = $(this).attr('data-handle');
				//console.log(selectedValueNew);

				$(".cu-optionsGrid .cu-option").each(function () {
					var cartProductMatchValue = $(this).find('.cu-option__mainText span').text();

					var cartProductMatchId = cartProductMatchValue.replace(/\D/g, '');

					if (cartProductMatchId == selectedValueNew) {
						$(this).trigger("click");
					}
				});

				$('[data-subscription-select]').val(selectedValueNew);
			});
		};

		ProductSubscription.init = function () {
			cacheDom();
			bindUIActions();
			bindUIActionsNew();
		};
	})(window.ProductSubscription = window.ProductSubscription || {}, _jquery2.default, undefined);
};